"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getTimeZoneOperation_1 = require("owa-service/lib/operation/getTimeZoneOperation");
function getTimeZone() {
    return getTimeZoneOperation_1.default({
        needTimeZoneList: true,
    }).then(function (response) { return response.TimeZoneList; });
}
exports.default = getTimeZone;
//# sourceMappingURL=getTimeZone.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/services/getTimeZone.js
// module id = 4922
// module chunks = 2